module.exports = __webpack_public_path__ + "img/oguraya_info.ece78abb.jpeg";